<template>
    <div class="cw-right-file">
        <header class="file-title">
            <span class="file-title-f">文件上传</span>
            <!-- <span class="file-title-l">查看更多</span> -->
        </header>
        <section class="file-wrapper">
            <div class="file-wrapper-img">
                <img src="@/assets/webImg/admin/workbench_upload1.svg" alt="">
            </div>
            <el-upload
                class="file-el-upload"
                :show-file-list="false"
                accept=".xls,.xlsx"
                action="/api/file"
                :before-upload="beforeFileUpload"
                :on-success="fileUploadSuccess"
                :on-error="fileUploadError"
                drag
            >
                <div class="upload-content" :style="`background: url(${require('@/assets/webImg/admin/workbench_upload2.svg')}) 0 20px no-repeat;`">
                    <button>点击上传</button>
                    <p>请将考勤、薪酬等文档直接拖拽到此处</p>
                </div>
            </el-upload>

        </section>
        <footer class="file-history">
            <div class="cw--card"></div>
            <div class="cw--card"></div>
        </footer>
    </div>
</template>

<script>

export default {

    components: {},

    data() {
        return {

        }
    },

    methods:{
        beforeFileUpload(file) {
            let isExcel = true;
            const isxls = file.type === "application/vnd.ms-excel";
            const isxlsx = file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
            const isLtM = file.size / 1024 / 1024 < 10;

            if (!isxls && !isxlsx) {
                isExcel = false;
                this.$message.error("导入文件只能是 xls,xlsx 格式!");
            }

            if (!isLtM) {
                this.$message.error("导入文件大小不能超过 10MB!");
            }

            this.$router.push({
                path: '/wage/data-ready-template',
            })

            return isExcel && isLtM;
        },

        fileUploadSuccess(res, file, fileList) {
            if (res) {
                if (file.status != "success" ) {
                    this.$message.error( res.msg );
                } else {

                    if (res.fileId) {
                        this.$message.success('上传成功');

                    } else{
                        this.$message.error(res.msg);
                    }

                }
            }
        },

        fileUploadError(err, file, fileList) {
            this.$message.error( "导入失败!" );
        },

    }
}

</script>

<style lang="scss" scoped>
.cw-right-file {
    padding: 10px 14px 18px 14px;
    .file-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .file-title-f {
            font-size: 18px;
            font-weight: 600;
            color: #333333;
            &::before {
                content: '';
                display: inline-block;
                width: 6px;
                height: 6px;
                margin-right: 10px;
                margin-bottom: 3px;
                border-radius: 100%;
                background: #84D9D5;
            }
        }
        .file-title-l {
            font-size: 15px;
            color: #999999;
            cursor: pointer;
            text-decoration:underline
        }
    }

    /** 文件上传 */
    .file-wrapper {
        width: 100%;
        .file-wrapper-img {
            height: 128px;
            width: 100%;
            margin-top: 15px;
            margin-bottom: 30px;
            img {
                height: 100%;
            }
        }
    }
    .file-el-upload {
        &::v-deep .el-upload-dragger {
            border-radius: 7px;
            border: 1px dashed #D6D6D6;
            width: 377px;
            height: 107px;
            overflow: unset;
            .upload-content {
                height: 100%;
                p {
                    margin-right: 10px;
                    color: #999999;
                    font-size: 15px;
                    line-height: 107px;
                    text-align: right;
                }
                button {
                    width: 115px;
                    height: 45px;
                    font-size: 16px;
                    color: #ffffff;
                    font-weight: bold;
                    background: #FFBE55;
                    border-radius: 7px;
                    position: absolute;
                    z-index: 1000;
                    top: -116px;
                    right: 10px;
                    outline: none;
                    border: none;
                    cursor: pointer;
                    overflow: hidden;
                }
            }
        }
    }

    .file-history {
        margin-top: 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

}
</style>
